import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend( utc );

type LocalDateInput = number | string | Date | undefined;

function getDayjsDate( timestamp: LocalDateInput ) {
    if ( !timestamp ) return undefined;

    if ( typeof timestamp === "number" && timestamp.toString().length === 10 ) {
        return dayjs.unix( timestamp );
    }

    return dayjs( timestamp );
}

function getGmtOffsetLabel( date: Date ): string {
    const offsetMinutes = -date.getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? "+" : "-";
    const absoluteMinutes = Math.abs( offsetMinutes );
    const hours = Math.floor( absoluteMinutes / 60 );
    const minutes = absoluteMinutes % 60;

    if ( minutes === 0 ) return `GMT${sign}${hours}`;

    return `GMT${sign}${String( hours ).padStart( 2, "0" )}:${String( minutes ).padStart( 2, "0" )}`;
}

export function formatLocalDate( timestamp: LocalDateInput, format: string = "YYYY-MM-DD HH:mm:ss" ): string {
    const date = getDayjsDate( timestamp );
    if ( !date ) return "";

    return date.local().format( format );
}

export function getLocalTimezoneLabel( timestamp?: LocalDateInput ): string {
    const dayjsDate = getDayjsDate( timestamp );
    const date = dayjsDate?.isValid() ? dayjsDate.toDate() : new Date();

    try {
        const timeZoneName = new Intl.DateTimeFormat( "en-US", { timeZoneName: "shortGeneric" } ).formatToParts( date )
            .find( part => part.type === "timeZoneName" )?.value;

        if ( timeZoneName ) return timeZoneName;
    } catch {
        return getGmtOffsetLabel( date );
    }

    return getGmtOffsetLabel( date );
}
